import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { AccessoriesOrder, AccessoriesOrderQuery } from "../type";

interface AccessoriesOrderState {
	list: AccessoriesOrder[];
	total: number;
	detail: AccessoriesOrder | null;
}

const initialState: AccessoriesOrderState = {
	list: [],
	total: 0,
	detail: null,
};

export const accessoriesOrderSlice = createSlice({
	name: "accessoriesOrder",
	initialState,
	reducers: {
		setAccessoriesOrders: (state, action) => {
			state.list = action.payload.data;
			state.total = action.payload.total;
		},
		setAccessoriesOrderDetail: (state, action) => {
			state.detail = action.payload.data;
		},
	},
});

export const selectAccessoriesOrderList = (state: RootState) =>
	state.accessoriesOrder.list;

export const selectAccessoriesOrderTotal = (state: RootState) =>
	state.accessoriesOrder.total;

export const selectAccessoriesOrderDetail = (state: RootState) =>
	state.accessoriesOrder.detail;

export const { setAccessoriesOrders, setAccessoriesOrderDetail } =
	accessoriesOrderSlice.actions;

export interface GetAccessoriesOrdersPayload {
	query: AccessoriesOrderQuery;
	callback?: () => void;
}

export const getAccessoriesOrdersAsync = createAction(
	"accessoriesOrder/getAccessoriesOrders",
	(payload: GetAccessoriesOrdersPayload) => ({
		payload: payload,
	}),
);

export interface GetAccessoriesOrderPayload {
	id: string;
	callback?: () => void;
}

export const getAccessoriesOrderAsync = createAction(
	"accessoriesOrder/getAccessoriesOrder",
	(payload: GetAccessoriesOrderPayload) => ({
		payload: payload,
	}),
);

export default accessoriesOrderSlice.reducer;
